import { Injectable } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  //#region form group properties
  addUpdateStockForm: FormGroup;
  addUpdateAssignmentForm: FormGroup;
  loginForm: FormGroup;
  addPartNumberForm: FormGroup;
  addStockForm: FormGroup;
  addAssignmentStockForm: FormGroup;
  addWarehouseStock: FormGroup;
  //#endregion

  //#region form builder functions
  addWarehouseStock_Fb() {
    this.addWarehouseStock = this._fb.group({
      partNumber: [null, Validators.required],
      orderQuantiry: [null, Validators.required],
      notes: [null],
    });
  }

  addUpdateStockForm_fb() {
    this.addUpdateStockForm = this._fb.group({
      name: [null, Validators.required],
      etaDate: [null, Validators.required],
      status: [null, Validators.required],
      containerNumber: [null],
    });
  }

  loginForm_fb() {
    this.loginForm = this._fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  addPartNumberForm_fb() {
    this.addPartNumberForm = this._fb.group({
      partNumber: [null, Validators.required],
      orderQuantiry: [null, Validators.required],
      notes: [null],
    });
  }

  addUpdateAssignmentForm_fb() {
    this.addUpdateAssignmentForm = this._fb.group({
      customerId: [null, Validators.required],
      invoiceId: [null, Validators.required],
      notes: [null],
      purchaseOrder: [null],
    });
  }

  addAssignmentStockForm_fb() {
    this.addAssignmentStockForm = this._fb.group({
      stockName: [null, Validators.required],
      partNumber: [null, Validators.required],
      partQuantity: [null, Validators.required],
    });
  }
  //#endregion
  constructor(private _fb: FormBuilder) {}
}
